module.exports = __webpack_public_path__ + "img/insta-icon.efc9b73e.svg";